import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet, FieldComponent} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-input'
import {Token} from '@/model/resource/Token'
import FileManagerWithList from '@/components/FileManagerWithList.vue'
import {$} from '@/facade'

export class InputTokenSchema extends DefaultSchema {
  readonly name = 'InputToken'

  readonly fieldSet: FieldSet<Token> = {
    imageUrl: (): FieldComponent => ({
      is: FileManagerWithList,
      bind: {
        folder: 'token',
        compressDimension: $.auth.global.dappImageDimension,
        crop: true,
        class: 'scoped__image-url',
      },
    }),
    title: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 70,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
